const KeenSlider = window.KeenSlider

const { setInitialised, useArrows } = window.BAO.Carousel.plugins

class FeaturedCollections extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this.els?.slide?.exists) return

    this.carousel = this.setupCarousel()
  }

  setupListeners () {
    super.setupListeners()

    this.onTabClick = this.onTabClick.bind(this)

    this.els.tab.elements.forEach((tab) => {
      this.listeners.add(tab, 'click', this.onTabClick)
    })
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: `${this.els.slide.selector}:not([aria-hidden='true'])`,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.5,
          spacing: 16,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 3.3,
              spacing: 20,
            },
          },
          '(min-width: 901px)': {
            slides: {
              perView: 3.7,
              spacing: 24,
            },
          },
        },
      },
      [
        setInitialised(),
        useArrows({
          container: this.els?.arrows?.element,
          next: this.els?.next?.element,
          previous: this.els?.previous?.element,
        }),
      ],
    )
  }

  onTabClick (e) {
    const { tab } = e.target.dataset

    this.els.tab.elements.forEach((el) =>
      el.setAttribute('aria-current', el.dataset.tab === tab),
    )
    this.els.slide.elements.forEach((el) =>
      el.setAttribute('aria-hidden', el.dataset.tab !== tab),
    )

    this.carousel.destroy()
    this.carousel = this.setupCarousel()
  }
}

if (!customElements.get('featured-collections')) {
  customElements.define('featured-collections', FeaturedCollections)
}
